module.exports = __webpack_public_path__ + "static/media/HeroStrawberrySalad.347887d1.jpg";